import clsx from 'clsx';
import { forwardRef, type ReactNode } from 'react';

import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';
import { canReceiveDefaultTextFormat as _canReceiveDefaultTextFormat } from '../../core/utils/can-receive-default-text-format.js';
import { textStyle as textStyleCSS } from '../../styles/textStyle.sty.js';
import { Heading } from '../../typography/heading/Heading.js';

//#region Typings
/**
 * Accepted properties for the TitleBar Title
 * @public
 */
export interface TitleBarTitleProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the TitleBar Title slot. */
  children: ReactNode;
}
//#endregion

/**
 * TitleBar Title component
 * @public
 */
export const Title = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  TitleBarTitleProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  }: TitleBarTitleProps = props;
  const childIsText = _canReceiveDefaultTextFormat(props.children);

  return (
    <div
      ref={forwardedRef}
      className={clsx(textStyleCSS({ textStyle: 'base' }), consumerClassName)}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {childIsText ? (
        <Heading level={3} as="h2">
          {children}
        </Heading>
      ) : (
        children
      )}
    </div>
  );
});
